<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>The Dead Travel Fast</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="9780312371111.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div class="contents" id="toc">
<a id="page08">
</a><a id="page09">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
</a><div class="contentsEntry" style="text-indent: 0%;"><a id="page09">
</a><p class="contentsEntryNumber" style="text-indent: 0%;"><a id="page09"></a><a href="#/9780312371111_ch01#ch01">I <br/>MONSTERS WANTED</a></p>
<p class="contentsEntryText" style="text-indent: 0%;">In which the author defines his vampire quest, dresses in a stinky mummy costume, watches too many movies, and then throws up.</p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312371111_ch02#ch02" title="Link target outside of Sample">II <br/>BERRIES IN A PAIL</span></p>
<p class="contentsEntryText" style="text-indent: 0%;">In which the author sets out to find vampires and in the process deconstructs Girls Gone Wild, fights off porn ads, and ponders the evolution off lies.</p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312371111_ch03#ch03" title="Link target outside of Sample">III <br/>I DON’T BELIEVE IN GOD; THE CRUCIFIX IS TO KEEP AWAY VAMPIRES</span></p>
<p class="contentsEntryText" style="text-indent: 0%;">In which the author travels to the land of the vampire and along the way deals with dog attacks, floods, possible amputation, and running out of hand sanitizer.</p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312371111_ch04#ch04" title="Link target outside of Sample">IV <br/>PULLING OUT THE FEATHERS FIRST</span></p>
<p class="contentsEntryText" style="text-indent: 0%;">As our story continues, the author searches for the hidden meaning of Friends, sees sixteen breasts, and is rocked like a hurricane.</p></div>
<a id="page10">
</a><div class="contentsEntry" style="text-indent: 0%;"><a id="page10">
</a><p class="contentsEntryNumber" style="text-indent: 0%;"><a id="page10"></a><span href="#/9780312371111_ch05#ch05" title="Link target outside of Sample">V <br/>FROM WAMPYR TO WHITBY</span></p>
<p class="contentsEntryText" style="text-indent: 0%;">In which the author travels to England to find exploding graves, great bargains at Top Shop, coffin-shaped candy, and gay men spilling into the streets.</p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312371111_ch06#ch06" title="Link target outside of Sample">VI <br/>GOD IS DEAD AND NO ONE CARES</span></p>
<p class="contentsEntryText" style="text-indent: 0%;">In which the author meets many vampires and two rats, then refuses to dress like a gay pirate.</p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312371111_ch07#ch07" title="Link target outside of Sample">VII <br/>I MAY BE DEAD, BUT I’M STILL PRETTY</span></p>
<p class="contentsEntryText" style="text-indent: 0%;">In which the author sits through 144 episodes of Buffy the Vampire Slayer, sits in the dark with 1,000 people, and cringes a lot.</p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312371111_ch08#ch08" title="Link target outside of Sample">VIII <br/>WELCOME TO DARKWING MANOR</span></p>
<p class="contentsEntryText" style="text-indent: 0%;">In which the author concludes his journey celebrating Halloween in Oregon, choking on PoliGrip, and trying not to contract salmonella.</p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312371111_ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="contentsEntryText" style="text-indent: 0%;">In which the author shouts out to his peeps, yo.</p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312371111_toc.vue?5cbbe77b